export default "__VITE_ASSET__VPPAzJXL__"